// function to act as a class
function MasterDetailRenderer() { }

// Initialize the component
MasterDetailRenderer.prototype.init = function (params) {

    // Save some stuff we'll need
    this.params = params;
    this.rowNode = params.node;
    this.rowId = params.node.id;
    this.masterGridAgApi = params.api;

    // Create the gui holding element
    this.guiElement = $("<div class='grid-master-details-container'></div>");

    // Kick off the template loading
    this.loadTemplate(params.getTemplate);
};

// Provides the primary gui element of the component
MasterDetailRenderer.prototype.getGui = function () {
    return this.guiElement[0];
};

// Figure out the template to use for the chunk of html that is going to contain the child content
MasterDetailRenderer.prototype.loadTemplate = function (loadingFunction) {

    var defaultTemplate = `<div ref="eDetailGrid"></div>`;

    // If a loading function wasn't provided, create a default one that just loads the default template
    loadingFunction = loadingFunction || function (params) {
        params.successCallback(defaultTemplate);
    };

    // Call the loading function, and provide it an async callback for when it has the template content
    loadingFunction({
        successCallback: function (template) {

            // If no template was provided, use default
            if (!template || template == "") {
                template = defaultTemplate;
            }

            // Create elements from the template
            this.guiElement.empty().append(template);

            // See if their is a container for the grid within it
            var gridContainer = this.guiElement.find("[ref='eDetailGrid']");

            // If a conainer for the grid exists, save it
            if (gridContainer.exists()) {
                this.detailGridContainer = gridContainer[0];
                this.createDetailsGrid();
            }
        }.bind(this)
    });
}

// Create the inner details grid
MasterDetailRenderer.prototype.createDetailsGrid = function () {

    var getOptionsFunction = this.params.getGridOptions;
    if (!getOptionsFunction) {
        console.warn('Could not find detail grid options for master detail,  please set gridOptions.detailCellRendererParams.getGridOptions');
        return;
    }

    // Call the options loading function
    getOptionsFunction({

        successCallback: function (gridOptions) {

            // IMPORTANT - gridOptions must be cloned
            this.detailGridOptions = _.clone(gridOptions);

            // Create the grid
            var lrsGridApi = rs.module("controls/data/grid").initialize($(this.detailGridContainer), this.detailGridOptions, this.params.httpHeaderNames, this.params.markers);

            // Need to keep ahold of the detail grid api
            this.detailGridAgApi = lrsGridApi.agGridApi;

            // See if there are attributes that need to be added to container
            var attributes = this.detailGridAgApi.pg.gridOptions.context["_lrs/output/attributes"];
            if (attributes) {
                for (const name in attributes) {
                    $(this.detailGridContainer).attr(name, attributes[name]);
                }
            }

            var gridInfo = {
                id: this.rowId,
                api: this.detailGridAgApi
            };

            // register with api
            this.masterGridAgApi.addDetailGridInfo(this.rowId, gridInfo);

            // register with node
            this.rowNode.detailGridInfo = gridInfo;

            // Now, finally read to load the rows
            this.loadRowData();

        }.bind(this)
    });
};

// Load the row data into the grid
MasterDetailRenderer.prototype.loadRowData = function () {

    var getRowDataFunction = this.params.getGridRowData;
    if (!this.params.getGridRowData) {
        console.warn('Could not find getGridRowData for master / detail, please set gridOptions.detailCellRendererParams.getGridRowData');
        return;
    }

    var rowDataParams = {
        node: this.params.node,
        data: this.params.data,
        successCallback: function (rowData) {

            // Ensure detail grid api still exists (grid may be destroyed when async call tries to set data)
            if (this.detailGridAgApi) {
                this.detailGridAgApi.updateGridOptions({ rowData });
            }

        }.bind(this)
    };

    getRowDataFunction(rowDataParams);
};


// Have to unregister the detail grid and destory it when this renderer is destoryed
MasterDetailRenderer.prototype.destroy = function () {

    // We may not have a detail grid if that wasn't apart of our template
    if (this.detailGridAgApi) {

        this.masterGridAgApi.removeDetailGridInfo(this.rowId);

        this.detailGridAgApi.destroy();
        this.detailGridAgApi = null;

        this.rowNode.detailGridInfo = null;
    }
};
